// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1KtHL","legacyBtn":"MutateMid_legacyBtn__JLMTv"};